import styled from '@emotion/styled';

import { COLORS, ZINDEX } from '../../../../styles/emotion';
import { ImageLayer } from '../ImageElement/ImageElement.styles';

export const Border = styled.div<{
  isFolded?: boolean;
  isRounded?: boolean;
}>`
  background-color: ${COLORS.WHITE};
  box-shadow: 0 6px 10px 3px rgba(0, 0, 0, 0.2);

  ${({ isFolded }) =>
    isFolded &&
    `
    position: absolute;
  `};

  ${({ isRounded }) => isRounded && `border-radius: 8px;`};
`;

export const CanvasBox = styled.div<{
  isFolded?: boolean;
  isMatchingTheme?: boolean;
  themeOverride?: string;
}>`
  position: relative;
  transform-origin: left top;

  ${({ isFolded, themeOverride }) =>
    isFolded &&
    themeOverride === 'Octavia' &&
    `
    ${ImageLayer} {
      &:first-of-type {
        z-index: 5 !important;
      }
      &:nth-of-type(2) {
        background-color: ${COLORS.WHITE};
      }
      &:nth-of-type(7) {
        z-index: 4 !important;
      }
    }
  `};

  ${({ isFolded, themeOverride }) =>
    isFolded &&
    themeOverride === 'Heaven' &&
    `
    ${ImageLayer} {
      &:nth-of-type(2) {
        display: none;
      }
    }
  `};

  ${({ isFolded, themeOverride }) =>
    isFolded &&
    themeOverride === 'Potter' &&
    `
    ${ImageLayer} {
      &:first-of-type {
        display: none;
      }
    }
  `};

  ${({ isFolded, themeOverride }) =>
    isFolded &&
    themeOverride === 'Sparrow' &&
    `
    ${ImageLayer} {
      &:nth-of-type(3) {
        display: none;
      }
    }
  `};

  ${({ isFolded, themeOverride }) =>
    isFolded &&
    themeOverride === 'Tamarine' &&
    `
    ${ImageLayer} {
      &:first-of-type {
        background-color: ${COLORS.WHITE};
      }
      &:nth-of-type(2) {
        z-index: 3 !important;
      }
    }
  `};

  ${({ isMatchingTheme, isFolded }) =>
    !isMatchingTheme &&
    isFolded &&
    `
    ${ImageLayer} {
      &:first-of-type {
        display: none;
      }
      &:nth-of-type(2) {
        display: none;
      }
      &:nth-of-type(4) {
        background-color: ${COLORS.WHITE};
      }
      &:nth-of-type(8) {
        background-color: transparent !important;
        z-index: ${ZINDEX.top} !important;
      }
    }
  `};
`;

export const CanvasBoxContainer = styled.div<{ isFolded?: boolean }>`
  ${({ isFolded }) => {
    if (isFolded) {
      return `
      margin-top: -100px !important;
      position: relative;
      transform: perspective(90px) rotateX(1deg);
      z-index: 2;
      `;
    }
    return `
      height: 100%;
    `;
  }};
`;

export const Folded = styled.div`
  background-color: ${COLORS.WHITE};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  content: '';
  display: block;
  height: 10px;
  margin-left: 7px;
  position: absolute;
  top: 139px;
  width: 150px;
`;

export const PreviewContainer = styled.div<{
  previewContainerDefaultSize?: boolean;
  withFrame?: boolean;
}>`
  align-self: flex-start;
  border-radius: 4px;
  height: 180px;
  padding: 8px;
  transform: translate3d(0, 0, 0);
  width: 180px;

  ${({ withFrame }) =>
    withFrame &&
    `
    background-color: ${COLORS.WHITE};
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  `};
`;

export const PreviewHand = styled.div`
  background-image: url('./assets/images/handDesktop.png');
  background-repeat: no-repeat;
  background-size: contain;
  bottom: -21px;
  height: 140px;
  position: absolute;
  width: 131px;
  z-index: 2;
`;
